import { render } from "./TemplateModalParkingBoard.vue?vue&type=template&id=e8c683c4&scoped=true&ts=true"
import script from "./TemplateModalParkingBoard.vue?vue&type=script&lang=ts"
export * from "./TemplateModalParkingBoard.vue?vue&type=script&lang=ts"

import "./TemplateModalParkingBoard.vue?vue&type=style&index=0&id=e8c683c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c683c4"]])

export default __exports__